import React from 'react';
import { Grid, Step, StepIcon, StepLabel, Stepper } from "@mui/material";

function StepperMenu({ activeStep, steps }) {

    function CustomStepIcon(props) {
        const { active, completed } = props;
        return (
            <StepIcon
                {...props}
                style={{
                    fontSize: '2.0rem',
                    color: '#4950de',
                    marginTop: '-7px',
                    zIndex: 1,
                    backgroundColor: active ? 'white' : '#fff',
                    opacity: completed || active ? 1 : 0.5,
                    borderRadius: '50%'
                }} />
        );
    }

    return (
        <Grid item xs={12} md={6}
            style={{
                paddingLeft: '1em',
                paddingTop: '1em',
                paddingBottom: '1em',
                width: '100%'
            }}>
            <Stepper activeStep={activeStep} alternativeLabel style={{ backgroundColor: '#fafafa', width: '30em' }}>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Grid >
    )
}
export default StepperMenu;